/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mTab.vue?vue&type=template&id=6edfa3d7&scoped=true"
import script from "./mTab.vue?vue&type=script&lang=js"
export * from "./mTab.vue?vue&type=script&lang=js"
import style0 from "./mTab.vue?vue&type=style&index=0&id=6edfa3d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edfa3d7",
  null
  
)

export default component.exports